// Aqui se centralizan los strings de las rutas al API
export class API {
    public static webApiBase = process.env.VUE_APP_ROOT_API;
    public static webApiBaseImages = process.env.VUE_APP_ROOT_PATH + 'Images/';
    public static webApiBaseRootPath = process.env.VUE_APP_ROOT_PATH;//'/'


    public static login = API.webApiBase + 'Login';
    public static usuarios = API.webApiBase + 'Usuarios';
    public static roles = API.webApiBase + 'Roles';
    public static VersionBack = API.webApiBase + 'VersionBack';
    /*************************** */
    public static SendingEmails = API.webApiBase + 'SendingEmails';
    public static servidor_smtp = API.webApiBase + 'servidor_smtp';
    public static usuario = API.webApiBase + 'usuarios';
    public static pantalla_lista = API.webApiBase + 'pantalla_lista';
    public static enumeracion = API.webApiBase + 'enumeraciones';
    public static Connect = API.webApiBase + 'Connect';
    public static cambioscontrasenasperdidas = API.webApiBase + 'cambioscontrasenasperdidas';
    public static rol = API.webApiBase + 'roles';
    public static mantenimiento_permiso = API.webApiBase + 'mantenimiento_permisos';
    public static permiso = API.webApiBase + 'permiso';
    public static TestAvatar = API.webApiBase + 'TestAvatar';
    public static menu_option = API.webApiBase + 'menu_options';
    public static public = API.webApiBase + 'public';
    public static cliente = API.webApiBase + 'clientes';
    public static Log = API.webApiBase + 'Log';
    public static variables = API.webApiBase + 'Variables';
    public static ui_logs = API.webApiBase + 'UiLogs';
    public static notificaciones = API.webApiBase + 'notificaciones';
    public static datos_empresa = API.webApiBase + 'datos_empresa';
    public static activeUsers = API.webApiBase + 'ActiveUsers';
    public static IpRateLimiting = API.webApiBase + 'IpRateLimiting';
    public static threatIntelligence = API.webApiBase + 'threatIntelligence';
    public static scheduledTasks = API.webApiBase + 'scheduled-tasks';
    public static agentsAdmin = API.webApiBase + 'agents-admin';
    public static agentSql = API.webApiBase + 'agent-sql';
    public static centros = API.webApiBase + 'centros';
    public static centros_servicios = API.webApiBase + 'centros_servicios';
    public static canales_entrada = API.webApiBase + 'canales_entrada';
    public static estados_cita = API.webApiBase + 'estados_cita';
    public static pacientes_leads = API.webApiBase + 'pacientes_leads';
    public static solicitudes_cita = API.webApiBase + 'solicitudes_cita';
    public static solicitudes_cita_estado_hist = API.webApiBase + 'solicitudes_cita_estado_hist';
    public static solicitudes_eventos_audit = API.webApiBase + 'solicitudes_eventos_audit';
    public static solicitudesWorkflow = API.webApiBase + 'solicitudes-workflow';
    public static publicAgenda = API.webApiBase + 'public-agenda';
    public static manychatLogs = API.webApiBase + 'manychat-logs';

}
